import { Component, Injector, ViewChild } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
    CreateDocumentBaseDto,
    DocumentServiceProxy
} from '@shared/service-proxies/service-proxies';
import moment from 'moment';
import { ModalDirective } from 'ngx-bootstrap/modal';

import { catchError, finalize } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Component({
    selector: 'uploadDocumentModal',
    templateUrl: './upload-document-modal.component.html'
})
export class UploadDocumentModalComponent extends AppComponentBase {
    @ViewChild('uploadDocumentModal', { static: true }) modal: ModalDirective;

    createDocument: CreateDocumentBaseDto = new CreateDocumentBaseDto();

    filecount: number;
    uploadcount: number = 0;
    ProgressSpinnerDlg: boolean = false;

    constructor(
        injector: Injector,
        private _documentServiceProxy: DocumentServiceProxy,
    ) {
        super(injector);
    }

    show(): void {
        this.modal.show();
    }

    close(): void {
        this.modal.hide();
    }

    DocumentUploader(event, fileUploadRef) {

        for (const file of event.files) {
            this.filecount = event.files.length;
            this.ProgressSpinnerDlg = true;
            if (this.filecount > 50) {
                this.notify.error(this.l('Oops! You can upload maximum 50 files'));
                this.ProgressSpinnerDlg = false;
                return;
            }

            //this.UploadDocumentWithFileBase64(file, fileUploadRef, event.files.length);

            let self = this;
            let promise = this.getFileBase64(file);
            promise.then(function (result) {
                self.uploadNewDocument(result, file.name, fileUploadRef, event.files.length);
            });

        }
    }

    uploadNewDocument(result, name, fileUploadRef: any, TotalUpload: number) {
        this.createDocument = new CreateDocumentBaseDto();
        this.createDocument.name = name;
        this.createDocument.type = '';
        let filebase64 = result as string;
        this.createDocument.file = (filebase64).split(',')[1];

        this._documentServiceProxy.create(this.createDocument)
            .pipe(
                catchError(
                    (err) => {
                        this.ProgressSpinnerDlg = false;
                        return throwError(err);
                    }
                )
            )
            .subscribe(result => {

                this.uploadcount++;

                if (this.uploadcount === TotalUpload) {
                    //Emit changes to parent component
                    //this.documents.emit();
                    fileUploadRef.clear();
                    this.notify.success(this.l('File uploaded successfully.'));

                    this.ProgressSpinnerDlg = false;

                    // Close Modal window
                    this.close();
                }

            });
    }

    getFileBase64(file) {
        return new Promise(function (resolve, reject) {
            let reader = new FileReader();
            reader.onload = function () { resolve(reader.result); };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }


    get chooseLabel(): string {
        return this.l('Ublion.UploadDocument.Choose');
    }
}
